import axios from "axios";
import { APP_SETTINGS } from "../../config";
import { getCountryTimeZone } from "../../assets";
export function loginUser(loginData) {
  loginData = {
    ...loginData,
    timezone: getCountryTimeZone(),
    deviceTypeId: 0,
    deviceToken: "string",
  };
  return axios.post(APP_SETTINGS.API_PATH.LOGIN.login, loginData);
}
export function loginCovisTourApi(loginData) {
  // loginData = {
  //     ...loginData,
  //     "timezone": getCountryTimeZone(),
  //     "deviceTypeId": 0,
  //     "deviceToken": "string",
  // }
  return axios.post(
    `${APP_SETTINGS.API_PATH.LOGIN.loginCovisTour}?userId=${loginData?.userId}`
  );
}

export function getTeamLeadsRequest() {
  return axios.get(APP_SETTINGS.API_PATH.USERS.getTeamLeads);
}

export function getUserListing(token) {
  return axios.get(APP_SETTINGS.API_PATH.USERS.getUsers, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}
export function getTeamMembers_API(userData, token) {
  // console.log('API hit');
  return axios.get(
    `${APP_SETTINGS.API_PATH.USERS.getTeamMembers}?teamLeadId=${userData.teamLeadId}&userId=${userData.userId}`,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export function getUserSelectListByRoleApi(token) {
  return axios.get(APP_SETTINGS.API_PATH.USERS.getEmployeesSelectListByRole, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}
